import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { WaveSine, Envelope, EnvelopeSimpleOpen } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <WaveSine size={26} weight="duotone" className="text-[#ccff00]" />
          <span className="font-display text-xl font-bold tracking-tight">TUNEAMPLIFIER</span>
        </Link>
        <div className="border border-zinc-800 rounded-2xl bg-zinc-900/50 p-8" data-testid="forgot-password-card">
          {!sent ? (
            <>
              <h1 className="font-display text-3xl font-bold">Reset password.</h1>
              <p className="text-sm text-zinc-400 mt-1 mb-6">Enter your email and we'll send a reset link.</p>
              <form onSubmit={submit} className="space-y-3">
                <div className="relative">
                  <Envelope size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
                  <Input data-testid="forgot-email-input" type="email" required placeholder="Email" value={email}
                    onChange={e => setEmail(e.target.value)} className="pl-9 bg-zinc-950 border-zinc-800" />
                </div>
                <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full btn-neon rounded-full font-display font-semibold h-11">
                  {loading ? 'Sending…' : 'Send reset link'}
                </Button>
              </form>
              <p className="text-center text-sm text-zinc-500 mt-6">
                <Link to="/login" className="text-[#ccff00] hover:underline">Back to log in</Link>
              </p>
            </>
          ) : (
            <div className="text-center" data-testid="forgot-sent-panel">
              <EnvelopeSimpleOpen size={40} weight="duotone" className="text-[#ccff00] mx-auto" />
              <h1 className="font-display text-2xl font-bold mt-4">Check your inbox.</h1>
              <p className="text-sm text-zinc-400 mt-2">If an account exists for <span className="font-mono text-zinc-100">{email}</span>, a reset link is on its way.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
